"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = Message;

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _media = require("react-components/media");

var _iconButton = require("./buttons/icon-button");

var _typography = require("./typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _breakpoint = require("@slyk/breakpoint");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var closeIcon = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13.25 2.75l-10.5 10.5m10.5 0L2.75 2.75\" stroke=\"currentColor\" stroke-miterlimit=\"10\"/></svg>";
var errorIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" d=\"M20.566 5.54c-2.974-4.194-14.162-4.192-17.132 0C2.478 6.887 2 9.204 2 12.49c0 3.285.478 5.603 1.434 6.95 2.875 4.054 14.181 4.325 17.132.166C21.52 18.257 22 15.886 22 12.49c0-3.286-.48-5.603-1.434-6.95z\"/><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M16.426 8.23l-8.853 8.54m8.853 0L7.573 8.23\"/></svg>";
var infoIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" d=\"M20.566 5.54c-2.974-4.194-14.162-4.192-17.132 0C2.478 6.887 2 9.204 2 12.49c0 3.285.478 5.603 1.434 6.95 2.875 4.054 14.181 4.325 17.132.166C21.52 18.257 22 15.886 22 12.49c0-3.286-.48-5.603-1.434-6.95z\"/><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M10.71 10.588c.445.65 2.134.65 2.58 0 .133-.205.205-.567.205-1.086 0-.519-.072-.868-.205-1.073-.434-.627-2.135-.676-2.58-.024-.134.205-.206.578-.206 1.097s.072.88.205 1.085zM12 17.33v-4.825\"/></svg>";
var successIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" d=\"M20.565 5.04C17.59.844 6.404.846 3.434 5.04c-.957 1.347-1.435 3.663-1.435 6.95 0 3.284.478 5.602 1.435 6.95 2.875 4.053 14.18 4.324 17.13.165C21.52 17.757 22 15.385 22 11.99c0-3.286-.48-5.602-1.434-6.95z\"/><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M16.27 9.402l-4.3 4.63a1.8 1.8 0 01-1.137.568h-.599a1.8 1.8 0 01-1.138-.568L7.73 12.576\"/></svg>";
var warningIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><g stroke=\"currentColor\" stroke-miterlimit=\"10\"><path d=\"M13.774 15.937c-.614-.895-2.934-.895-3.548 0-.182.281-.281.779-.281 1.492 0 .712.099 1.193.281 1.475.597.862 2.934.928 3.548.033.182-.282.282-.796.282-1.508 0-.713-.1-1.21-.282-1.492z\"/><path d=\"M1.458 20.114a1.9 1.9 0 010-1.923l4.011-6.945L9.481 4.3a1.901 1.901 0 011.657-.961h1.724c.68 0 1.326.365 1.658.961l4.011 6.946 4.012 6.945a1.9 1.9 0 010 1.923l-.862 1.492a1.921 1.921 0 01-1.658.961H3.977c-.68 0-1.31-.364-1.657-.961l-.862-1.492z\"/><path d=\"M1.458 20.114a1.9 1.9 0 010-1.923l4.011-6.945L9.481 4.3a1.901 1.901 0 011.657-.961h1.724c.68 0 1.326.365 1.658.961l4.011 6.946 4.012 6.945a1.9 1.9 0 010 1.923l-.862 1.492a1.921 1.921 0 01-1.658.961H3.977c-.68 0-1.31-.364-1.657-.961l-.862-1.492zM12 6.67v6.631\"/></g></svg>";
/**
 * Export `MessageType` type.
 */

/**
 * Icons.
 */
var icons = {
  error: errorIcon,
  info: infoIcon,
  success: successIcon,
  warning: warningIcon
};
/**
 * `Wrapper` styled component.
 */

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "message__Wrapper",
  componentId: "sc-6lwq5o-0"
})(["border-radius:", "px;display:flex;min-height:42px;position:relative;", ""], (0, _styledTools.theme)('dimensions.borderRadius'), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 52px;\n  "]))));
/**
 * `IconWrapper` styled component.
 */


var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "message__IconWrapper",
  componentId: "sc-6lwq5o-1"
})(["align-items:center;border-radius:4px 0 0 4px;display:flex;justify-content:center;padding:13px 12px;position:relative;", " ", ""], (0, _styledTools.switchProp)('type', {
  error: (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('danger')),
  info: (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('info')),
  success: (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('success')),
  warning: (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.color)('warning'))
}), _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 14px 16px;\n  "]))));
/**
 * `ContentWrapper` styled component.
 */


var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "message__ContentWrapper",
  componentId: "sc-6lwq5o-2"
})(["align-items:center;border:1px solid;border-bottom-right-radius:", "px;border-left:none;border-top-right-radius:", "px;display:grid;flex:1;grid-template-areas:'text close';grid-template-columns:1fr max-content;padding-left:12px;padding-right:12px;position:relative;", " ", ""], (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.switchProp)('type', {
  error: (0, _styledComponents.css)(["background-color:", ";border-color:", ";color:", ";"], (0, _styles.color)('danger100'), (0, _styles.color)('danger500'), (0, _styles.color)('danger500')),
  info: (0, _styledComponents.css)(["background-color:", ";border-color:", ";color:", ";"], (0, _styles.color)('info100'), (0, _styles.color)('info500'), (0, _styles.color)('info500')),
  success: (0, _styledComponents.css)(["background-color:", ";border-color:", ";color:", ";"], (0, _styles.color)('success100'), (0, _styles.color)('success500'), (0, _styles.color)('success900')),
  warning: (0, _styledComponents.css)(["background-color:", ";border-color:", ";color:", ";"], (0, _styles.color)('warning100'), (0, _styles.color)('warning500'), (0, _styles.color)('warning700'))
}), _styles.media.min('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-left: 16px;\n    padding-right: 16px;\n  "]))));
/**
 * `StyledText` styled component.
 */


var StyledText = (0, _styledComponents["default"])(_typography.Text).attrs({
  size: 'small'
}).withConfig({
  displayName: "message__StyledText",
  componentId: "sc-6lwq5o-3"
})(["color:inherit;grid-area:text;padding:6px 0;"]);
/**
 * `StyledIconButton` styled component.
 */

var StyledIconButton = (0, _styledComponents["default"])(_iconButton.IconButton).withConfig({
  displayName: "message__StyledIconButton",
  componentId: "sc-6lwq5o-4"
})(["grid-area:close;margin-left:12px;margin-right:-6px;"]);
/**
 * Export `Message` component.
 */

function Message(props) {
  var children = props.children,
      className = props.className,
      onClose = props.onClose,
      type = props.type;

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var isDesktop = (0, _breakpoint.useBreakpoint)('md', 'min');
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(IconWrapper, {
    type: type
  }, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: (0, _styles.color)('white'),
    icon: (0, _get2["default"])(icons, type),
    size: isDesktop ? '24px' : '16px'
  })), /*#__PURE__*/_react["default"].createElement(ContentWrapper, {
    type: type
  }, /*#__PURE__*/_react["default"].createElement(StyledText, !(0, _isString2["default"])(children) ? {
    as: 'div'
  } : {}, children), onClose && /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    "aria-label": translate('common.actions.close'),
    colorTheme: 'transparent',
    icon: closeIcon,
    iconSize: 'small',
    onClick: onClose,
    size: 'small'
  })));
}